<button (click)="emitClear()" class="button">{{this.text}}</button>